// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminProductPageContainer {
  padding: 16px;
  width: 80vw;
  margin-top: 1vh;
  align-items: center;
}

.adminProductPageHeading,
.adminProductSearchLabel,
.adminProductPageContainer .cat-container {
  color: #247a97;
  font-size: 1.75rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
}

.adminProductPageContainer .cat-container {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background-color: #f3f4f6;
  padding: 8px;
  border-radius: 8px;
}

.adminProductPageContainer .category-change,
.adminProductPageContainer .addProductButton {
  font-size: 1.5rem;
  margin-left: 0.5rem;
}

.adminProductSearch {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 16px;
}

.adminProductSearchControl {
  flex-basis: calc(33.3% - 1rem);
}

.adminProductSearchInput,
.adminProductCategorySelect,
.adminProductActionButton,
.adminProductModalActionButton {
  padding: 8px 20px;
  border-radius: 4px;
  font-size: 1rem;
  background-color: white;
  border: 1px solid #cccccc;
}

.adminProductTableWrapper {
  margin-top: 1rem;
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow-x: auto;
}

.adminProductTable {
  width: 100%;
  border-collapse: collapse;
}

.adminProductTableHeader th {
  background-color: #e2e2e2;
  color: #247a97;
  font-size: 1.5rem;
  padding: 8px;
  text-align: left;
}

.adminProductTable tr {
  border: 1px solid #ccc;

  &:hover {
    background-color: #e2e2e2;
    transition: ease 0.3s;
    transform: scale(0.95);
  }
}

.product__name {
  font-size: 1.15rem;
  color: #505050;
  font-weight: 600;
}

.adminProductTableRow:hover,
.adminProductTableHeaderRow:hover {
  background-color: #e5e7eb;
}

.adminProductTableCell {
  padding: 8px;
  font-size: 1.25rem;
  vertical-align: middle;
  text-align: left;
}

.adminProductActionButton:hover,
.adminProductModalActionButton:hover {
  background-color: #22c55e;
}

.adminProductPagination {
  display: flex;
  justify-content: center;
  padding-top: 16px;
}

.adminProductPaginationItem {
  padding: 8px;
  font-size: 1rem;
  margin: 0 4px;
  border-radius: 4px;
  background-color: white;
  border: 1px solid #cccccc;
}

.adminProductPaginationItem:hover {
  background-color: #e2e2e2;
}

.adminProductPaginationPage {
  margin-left: 1rem;
  margin-right: 1rem;
}

.adminProductPageContainer .modal__body,
.adminProductPageContainer .modal__container2 {
  padding: 15px;
  width: 50vw;
  font-size: 1rem;
}

.adminProductPageContainer .modal_form .label-text,
.adminProductPageContainer .modal_form input.input-bordered {
  font-size: 1.5rem;
}

/* Description Text */
.adminProductPageContainer
  .modal_form
  textarea.textarea-product.input-bordered {
  font-size: 1.25rem;
}

.adminProductPageContainer .product-image {
  width: 50vw;
  -o-object-fit: fill;
     object-fit: fill;
}

.adminProductPageContainer .textarea-product {
  width: 320px;
  height: 10vh;
}

.adminProductModal {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 75vw;
  max-width: 1000px;
  padding: 16px;
  margin: auto;
}

.adminProductModalHeader {
  font-size: 1.75rem;
  font-weight: bold;
  color: #247a97;
  text-align: center;
  margin-bottom: 16px;
}

.adminProductModalContent {
  display: flex;
  flex-direction: column;
}

.adminProductModalActions {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
}

.adminProductModalActionButton {
  margin-left: 8px;
  padding: 8px 16px;
  background-color: #247a97;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

.adminProductModalActionButton:hover {
  background-color: #22c55e;
}

/* Specific styles for elements within the admin product page */
.adminProductPageContainer .product__category {
  font-weight: bold;
  font-size: 1.25rem;
}

.adminProductPageContainer .mask img {
  width: 5rem;
  height: 5rem;
  -o-object-fit: fill;
     object-fit: fill;
  border-radius: 15px;
}

.adminProductPageContainer .spinner-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
}

.adminProductPageContainer .spinner-avatar img {
  margin-right: 5px;
}

.adminProductPageContainer .detailsButton {
  padding: 8px 16px;
  background-color: #247a97;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

.adminProductPageContainer .detailsButton:hover {
  background-color: #22c55e;
}

/* Save Button */
.save-button-primary {
  border: none;
  color: #fff;
  background-image: linear-gradient(30deg, #0400ff, #4ce3f7);
  border-radius: 20px;
  background-size: 100% auto;
  font-family: inherit;
  font-size: 17px;
  padding: 0.6em 1.5em;
}

.save-button-primary:hover {
  background-position: right center;
  background-size: 200% auto;
  animation: pulse512 1.5s infinite;
}

@keyframes pulse512 {
  0% {
    box-shadow: 0 0 0 0 #05bada66;
  }

  70% {
    box-shadow: 0 0 0 10px rgb(218 103 68 / 0%);
  }

  100% {
    box-shadow: 0 0 0 0 rgb(218 103 68 / 0%);
  }
}

@media (max-width: 991px) {
  .adminProductTable tr {
    border: 1px solid #ccc;

    &:hover {
      background-color: #e2e2e2;
      transition: ease 0.3s;
      transform: scale(0.95);
    }
  }

  .product__name {
    font-size: 2rem;
    color: #247a97;
    font-weight: 600;
  }

  .product__material {
    margin-top: 10px;
    font-style: italic;
  }

  .adminProductTableHeader th,
  .product__material,
  .table__cell {
    /* table__cell is Product Price */
    font-size: 1.75rem;
  }

  /* text description of product*/
  .text-ellipsis {
    font-size: 1.25rem;
  }

  .product__category {
    font-size: 1.65rem;
    margin-top: 10px;
  }

  /* Actions */
  .adminProductPageContainer .adminProductTable td:last-child .cat-container {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: self-start;
    padding: 5px;
  }

  /* Actions Buttons*/
  .adminProductPageContainer
    .adminProductTable
    td:last-child
    .cat-container
    .detailsButton,
  .adminProductPageContainer
    .adminProductTable
    td:last-child
    .cat-container
    .delete-button:hover::before {
    font-size: 1.15rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/AdminProductPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;EAIE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;;EAEtB;IACE,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAgB;KAAhB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+DAA+D;AAC/D;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAgB;KAAhB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,WAAW;EACX,0DAA0D;EAC1D,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAE1B,iCAAiC;AACnC;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,sBAAsB;;IAEtB;MACE,yBAAyB;MACzB,qBAAqB;MACrB,sBAAsB;IACxB;EACF;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;;IAGE,iCAAiC;IACjC,kBAAkB;EACpB;;EAEA,+BAA+B;EAC/B;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,YAAY;EACZ;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,YAAY;EACd;;EAEA,mBAAmB;EACnB;;;;;;;;;;IAUE,kBAAkB;EACpB;AACF","sourcesContent":[".adminProductPageContainer {\n  padding: 16px;\n  width: 80vw;\n  margin-top: 1vh;\n  align-items: center;\n}\n\n.adminProductPageHeading,\n.adminProductSearchLabel,\n.adminProductPageContainer .cat-container {\n  color: #247a97;\n  font-size: 1.75rem;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.adminProductPageContainer .cat-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  background-color: #f3f4f6;\n  padding: 8px;\n  border-radius: 8px;\n}\n\n.adminProductPageContainer .category-change,\n.adminProductPageContainer .addProductButton {\n  font-size: 1.5rem;\n  margin-left: 0.5rem;\n}\n\n.adminProductSearch {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 16px;\n}\n\n.adminProductSearchControl {\n  flex-basis: calc(33.3% - 1rem);\n}\n\n.adminProductSearchInput,\n.adminProductCategorySelect,\n.adminProductActionButton,\n.adminProductModalActionButton {\n  padding: 8px 20px;\n  border-radius: 4px;\n  font-size: 1rem;\n  background-color: white;\n  border: 1px solid #cccccc;\n}\n\n.adminProductTableWrapper {\n  margin-top: 1rem;\n  background-color: #ffffff;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  overflow-x: auto;\n}\n\n.adminProductTable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.adminProductTableHeader th {\n  background-color: #e2e2e2;\n  color: #247a97;\n  font-size: 1.5rem;\n  padding: 8px;\n  text-align: left;\n}\n\n.adminProductTable tr {\n  border: 1px solid #ccc;\n\n  &:hover {\n    background-color: #e2e2e2;\n    transition: ease 0.3s;\n    transform: scale(0.95);\n  }\n}\n\n.product__name {\n  font-size: 1.15rem;\n  color: #505050;\n  font-weight: 600;\n}\n\n.adminProductTableRow:hover,\n.adminProductTableHeaderRow:hover {\n  background-color: #e5e7eb;\n}\n\n.adminProductTableCell {\n  padding: 8px;\n  font-size: 1.25rem;\n  vertical-align: middle;\n  text-align: left;\n}\n\n.adminProductActionButton:hover,\n.adminProductModalActionButton:hover {\n  background-color: #22c55e;\n}\n\n.adminProductPagination {\n  display: flex;\n  justify-content: center;\n  padding-top: 16px;\n}\n\n.adminProductPaginationItem {\n  padding: 8px;\n  font-size: 1rem;\n  margin: 0 4px;\n  border-radius: 4px;\n  background-color: white;\n  border: 1px solid #cccccc;\n}\n\n.adminProductPaginationItem:hover {\n  background-color: #e2e2e2;\n}\n\n.adminProductPaginationPage {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n.adminProductPageContainer .modal__body,\n.adminProductPageContainer .modal__container2 {\n  padding: 15px;\n  width: 50vw;\n  font-size: 1rem;\n}\n\n.adminProductPageContainer .modal_form .label-text,\n.adminProductPageContainer .modal_form input.input-bordered {\n  font-size: 1.5rem;\n}\n\n/* Description Text */\n.adminProductPageContainer\n  .modal_form\n  textarea.textarea-product.input-bordered {\n  font-size: 1.25rem;\n}\n\n.adminProductPageContainer .product-image {\n  width: 50vw;\n  object-fit: fill;\n}\n\n.adminProductPageContainer .textarea-product {\n  width: 320px;\n  height: 10vh;\n}\n\n.adminProductModal {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  width: 75vw;\n  max-width: 1000px;\n  padding: 16px;\n  margin: auto;\n}\n\n.adminProductModalHeader {\n  font-size: 1.75rem;\n  font-weight: bold;\n  color: #247a97;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.adminProductModalContent {\n  display: flex;\n  flex-direction: column;\n}\n\n.adminProductModalActions {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 16px;\n}\n\n.adminProductModalActionButton {\n  margin-left: 8px;\n  padding: 8px 16px;\n  background-color: #247a97;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.adminProductModalActionButton:hover {\n  background-color: #22c55e;\n}\n\n/* Specific styles for elements within the admin product page */\n.adminProductPageContainer .product__category {\n  font-weight: bold;\n  font-size: 1.25rem;\n}\n\n.adminProductPageContainer .mask img {\n  width: 5rem;\n  height: 5rem;\n  object-fit: fill;\n  border-radius: 15px;\n}\n\n.adminProductPageContainer .spinner-avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.adminProductPageContainer .spinner-avatar img {\n  margin-right: 5px;\n}\n\n.adminProductPageContainer .detailsButton {\n  padding: 8px 16px;\n  background-color: #247a97;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.adminProductPageContainer .detailsButton:hover {\n  background-color: #22c55e;\n}\n\n/* Save Button */\n.save-button-primary {\n  border: none;\n  color: #fff;\n  background-image: linear-gradient(30deg, #0400ff, #4ce3f7);\n  border-radius: 20px;\n  background-size: 100% auto;\n  font-family: inherit;\n  font-size: 17px;\n  padding: 0.6em 1.5em;\n}\n\n.save-button-primary:hover {\n  background-position: right center;\n  background-size: 200% auto;\n  -webkit-animation: pulse 2s infinite;\n  animation: pulse512 1.5s infinite;\n}\n\n@keyframes pulse512 {\n  0% {\n    box-shadow: 0 0 0 0 #05bada66;\n  }\n\n  70% {\n    box-shadow: 0 0 0 10px rgb(218 103 68 / 0%);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgb(218 103 68 / 0%);\n  }\n}\n\n@media (max-width: 991px) {\n  .adminProductTable tr {\n    border: 1px solid #ccc;\n\n    &:hover {\n      background-color: #e2e2e2;\n      transition: ease 0.3s;\n      transform: scale(0.95);\n    }\n  }\n\n  .product__name {\n    font-size: 2rem;\n    color: #247a97;\n    font-weight: 600;\n  }\n\n  .product__material {\n    margin-top: 10px;\n    font-style: italic;\n  }\n\n  .adminProductTableHeader th,\n  .product__material,\n  .table__cell {\n    /* table__cell is Product Price */\n    font-size: 1.75rem;\n  }\n\n  /* text description of product*/\n  .text-ellipsis {\n    font-size: 1.25rem;\n  }\n\n  .product__category {\n    font-size: 1.65rem;\n    margin-top: 10px;\n  }\n\n  /* Actions */\n  .adminProductPageContainer .adminProductTable td:last-child .cat-container {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    align-items: self-start;\n    padding: 5px;\n  }\n\n  /* Actions Buttons*/\n  .adminProductPageContainer\n    .adminProductTable\n    td:last-child\n    .cat-container\n    .detailsButton,\n  .adminProductPageContainer\n    .adminProductTable\n    td:last-child\n    .cat-container\n    .delete-button:hover::before {\n    font-size: 1.15rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
